module.exports = __webpack_public_path__ + "static/media/type-1.10957e7d.svg";